import React, { useState } from 'react';
import Logo from '../../components/common/Logo';
import { Users, Stethoscope, BookOpen, Calendar } from 'lucide-react';
import AdminSidebar from '../../components/admin/AdminSidebar';
import { Link } from 'react-router-dom';
import StatisticsService from '../../services/statistics.service';
import { useEffect } from 'react';
import ActivityLogsList from '../../components/admin/ActivityLogsList';
import InactiveTherapistsView from '../../components/admin/InactiveTherapistsView';

const AdminDashboard = () => {

  const [statistics, setStatistics] = useState({
    doctors: { total: 0, active: 0 },
    patients: { total: 0, active: 0 },
    services: { total: 0, active: 0 },
    appointments: { total: 0, active: 0 },
    pendingApprovals: 7,
    monthlyAppointments: 320
  });

  useEffect(() => {
    loadStatistics();
  }, []);

  const loadStatistics = async () => {
    try {
      const data = await StatisticsService.getStatistics();
      setStatistics(prevStats => ({
        ...prevStats,
        doctors: data.doctors,
        patients: data.patients,
        services: data.services,
        appointments: data.appointments
      }));
    } catch (error) {
      console.error('[DEBUG] Error loading statistics:', error);
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <AdminSidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 bg-gray-50 p-8">
        <header className="mb-8">
          <h1 className="text-2xl font-bold">Dashboard Amministrazione</h1>
          <p className="text-gray-600">Panoramica del sistema</p>
        </header>

        {/* Statistiche principali */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Totale Dottori</p>
            <p className="text-2xl font-bold">{statistics.doctors.total}</p>
            <p className="text-sm text-green-600">
              {statistics.doctors.active} attivi
            </p>
          </div>
          <Stethoscope className="w-12 h-12 text-blue-500 opacity-20" />
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Totale Pazienti</p>
            <p className="text-2xl font-bold">{statistics.patients.total}</p>
            <p className="text-sm text-green-600">
              {statistics.patients.active} attivi
            </p>
          </div>
          <Users className="w-12 h-12 text-green-500 opacity-20" />
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Servizi Totali</p>
            <p className="text-2xl font-bold">{statistics.services?.total || 0}</p>
          </div>
          <BookOpen className="w-12 h-12 text-indigo-500 opacity-20" />
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Appuntamenti Totali</p>
            <p className="text-2xl font-bold">{statistics.appointments?.total || 0}</p>
            <p className="text-sm text-green-600">
              {statistics.appointments?.monthly || 0} questo mese
            </p>
          </div>
          <Calendar className="w-12 h-12 text-orange-500 opacity-20" />
        </div>
      </div>
    </div>


        {/* Attività recenti e Approvazioni */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Attività Recenti */}
          <ActivityLogsList />

          {/* Approvazioni in Sospeso */}
         <InactiveTherapistsView />

          <div className="mt-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold">Gestione Questionario</h2>
                <Link
                  to="/admin/survey/questions"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Gestisci Domande
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;



